import type { ItemStoreState } from "@editor/items/ItemStore";
import type { ActionItem } from "@editor/items/action/ActionItem";
import type { SimulationItem } from "@editor/items/simulation/SimulationItem";

export default {
  applyToVersions: "<2.6.1",
  type: "before",
  name: "move all ids to unique ids",
  migrate(data: {
    simulations?: ItemStoreState<SimulationItem>;
    measures?: ItemStoreState<ActionItem>;
  }) {
    if (!data.simulations) return data;

    outer: for (const simId in data.simulations.items) {
      const simulation: SimulationItem = data.simulations.items[simId];

      for (const round of simulation.rounds) {
        // stop the whole process if activated measures exist already
        if (round.activatedMeasures) break outer;

        const activatedMeasures = [];

        const actionPlan = simulation.actionPlans[round.index];
        const plannedMeasureIds = actionPlan.plannedMeasureIds;
        for (const measureId of plannedMeasureIds) {
          if (measureId in round.preventedMeasures) {
            continue;
          }
          if (measureId in round.notPayableMeasures) {
            continue;
          }

          const measure = data?.measures?.items?.[measureId];
          if (measure == null) continue;

          activatedMeasures.push({
            measureId: measure.id,
            costs: measure.costs
          });
        }

        round.activatedMeasures = activatedMeasures;
      }
    }

    return data;
  }
};
